var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.remain)?_c('div',{ref:"elem",staticClass:"timer"},[_vm._v(" "+_vm._s(_vm.remain)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }